var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-home-wrap"},[_c('Header'),_c('Swiper'),_c('Advantage'),_c('Example'),_c('Bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }